var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: ', ';\n  margin-top: ', ';\n  margin-left: ', ';\n  margin-right: ', ';\n  flex-direction: row;\n  @media (max-width: 767px) {\n    flex-direction: column;\n    justify-content: center;\n    & > div {\n      margin-left: 8px;\n    }\n  }\n  & > div {\n    /* margin-top: 13px;\n    margin-bottom: 13px; */\n    margin-right: 8px;\n  }\n  button {\n    margin: 0px 0px 8px 0px;\n  }\n\n  @media (max-width: 450px) {\n    > div {\n      min-width: ', ';\n      max-width: 100%;\n    }\n    button {\n      min-width: 0;\n    }\n  }\n'], ['\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: ', ';\n  margin-top: ', ';\n  margin-left: ', ';\n  margin-right: ', ';\n  flex-direction: row;\n  @media (max-width: 767px) {\n    flex-direction: column;\n    justify-content: center;\n    & > div {\n      margin-left: 8px;\n    }\n  }\n  & > div {\n    /* margin-top: 13px;\n    margin-bottom: 13px; */\n    margin-right: 8px;\n  }\n  button {\n    margin: 0px 0px 8px 0px;\n  }\n\n  @media (max-width: 450px) {\n    > div {\n      min-width: ', ';\n      max-width: 100%;\n    }\n    button {\n      min-width: 0;\n    }\n  }\n']);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React, { Component } from 'react';
import { length, is, filter } from 'ramda';
import styled from 'styled-components';
var ButtonContainer = styled.div(_templateObject, function (props) {
  return props.alignment;
}, function (props) {
  return props.theme.spaces.tight;
}, function (props) {
  return props.margin;
}, function (props) {
  return props.margin;
}, function (props) {
  return props.minWidth;
});

var MobileButtonList = function (_Component) {
  _inherits(MobileButtonList, _Component);

  function MobileButtonList() {
    _classCallCheck(this, MobileButtonList);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  MobileButtonList.prototype.render = function render() {
    var children = this.props.children || [];
    var alignment = this.props.alignment || 'center';
    var l = length(filter(is(Object), children));
    var minWidth = l > 1 ? '40%' : '0';
    var margin = l > 1 ? '24px' : '0px';
    return React.createElement(ButtonContainer, {
      className: 'a-buttons',
      margin: margin,
      minWidth: minWidth,
      alignment: alignment
    }, this.props.children);
  };

  return MobileButtonList;
}(Component);

export default MobileButtonList;